import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white">
      <div className="max-w-screen-lg p-4 mx-auto flex-col justify-center w-full h-full">
        <div className="pb-8 ">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">About</p>
        </div>
        <p className="text-xl mt-10">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Praesentium
          provident eaque officia ipsam recusandae velit possimus, illo fuga
          commodi dicta sapiente reiciendis, atque deserunt dolorum laudantium
          culpa quo repudiandae quasi! Laborum magni ea ullam recusandae
          perferendis facilis dignissimos iure culpa, ipsam ducimus. Enim
          doloremque, ullam neque voluptatem dolores reprehenderit consequatur!
        </p>
        <br />
        <p className="text-xl">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Rerum
          assumenda sint ipsum nulla perferendis quibusdam eos quos qui ea.
          Deleniti accusantium consectetur quis ab nisi vel ducimus laborum
          veritatis atque quisquam distinctio rem qui necessitatibus reiciendis
          dolorem, laudantium doloribus architecto itaque beatae alias pariatur
          placeat ipsam repellendus facilis. Natus, quos?
        </p>
      </div>
    </div>
  );
};

export default About;
